/** Format a decimal-string amount as IDR, e.g. "11100000.00" → "Rp 11.100.000". */
export function formatIDR(amount: string | number | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '—';
  const n = typeof amount === 'string' ? Number(amount) : amount;
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(n);
}

/** Format an ISO date / YYYY-MM-DD as a short local date. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

/**
 * The date a milestone effectively sits on — the engine-scheduled date when the
 * graph has moved it ("graph wins"), else the typed due date — plus the original
 * due date when they differ, so callers can show a "moved from …" hint. Matches
 * where the Gantt draws the diamond and how its status is computed.
 */
export function milestoneEffectiveDate(m: {
  dueDate: string;
  scheduledDate?: string | null;
}): { date: string; movedFrom: string | null } {
  const date = m.scheduledDate ?? m.dueDate;
  return { date, movedFrom: m.scheduledDate && m.scheduledDate !== m.dueDate ? m.dueDate : null };
}

/** Human label for a snake/lower status, e.g. "partially_paid" → "Partially paid". */
export function humanizeStatus(status: string): string {
  const s = status.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** MUI chip color for a status across entities. */
export function statusColor(
  status: string,
): 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info' {
  switch (status) {
    case 'paid':
    case 'accepted':
    case 'active':
    case 'delivered':
      return 'success';
    case 'overdue':
    case 'rejected':
    case 'cancelled':
    case 'void':
    case 'flagged':
      return 'error';
    case 'partially_paid':
    case 'ready_to_invoice':
    case 'sent':
      return 'warning';
    case 'issued':
    case 'invoiced':
    case 'closed':
      return 'info';
    default:
      return 'default';
  }
}
